<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        classTabContent="pl-12 pr-12"
                        class="mt-3"
                        :data="tabData"
                        activeKey="opening_case">
                    <template slot="gofixTab:opening_case">
                        <CaseListing :case_status="'Opening'" />
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    const CaseListing = () => import("../caseManagement/CaseListing")
    export default {
        name: 'joblist-all',
        components: {
            CaseListing
        },
        data() {
            return{
                tabData:[
                    {
                        key: "opening_case",
                        title: "Open",
                        active: false,
                        link: `/case/list-opening`
                    },
                    {
                        key: "closed_case",
                        title: "Closed",
                        active: false,
                        link: `/case/list-closed`
                    },
                    {
                        key: "all_case",
                        title: "ALL",
                        active: true,
                        link: `/case/list`
                    },
                ]
            }
        },

        computed: {

        },
        async created() {


        },
        watch: {

        },
        methods: {

        }
    }
</script>
